"use client";
import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import { useDarkMode } from '../darkModeContext';
import { FaInstagram } from "react-icons/fa";
import { MdOutlineContactSupport } from "react-icons/md";
import { TfiWorld } from "react-icons/tfi";
import { IoCloseOutline } from "react-icons/io5";
import Link from 'next/link';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import "./navbar.css";


function MainNavbar() {
    const { t, i18n } = useTranslation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const isDarkMode = useDarkMode();
    const [activeKey, setActiveKey] = useState(null);
    

    let tabs = {
        home: { label: t("tabs.home"), path: "/" },
        bamboo: { label: t("tabs.bamboo"), path: "/bamboo" },
        mecanicals: { label: t("tabs.mecanicals"), path: "/mecanicals" },
        construction: { label: t("tabs.construction"), path: "/construction" },
        news: { label: t("tabs.news"), path: "/news" } 
    };

    useEffect(() => {
        if (typeof window === 'undefined') return;  // Ensure this code only runs on the client
    
        const handleScroll = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            if (scrollTop !== 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
    
        handleScroll(); // This will check the scroll position immediately
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    
    useEffect(() => {
        if (typeof document === 'undefined') return; // Ensure this code only runs on the client
    
        // Close the navbar if clicked outside
        const handleClickOutside = (event) => {
            const navbarCollapse = document.querySelector('.navbar-collapse');
            if (navbarCollapse && !navbarCollapse.contains(event.target) && isOpen) {
                setIsOpen(false); // Close the navbar if clicked outside
            }
        };
    
        document.addEventListener('click', handleClickOutside);
    
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isOpen]);


    const handleNavClick = (key) => {
        setActiveKey(key);  
        // Close the navbar-collapse
        setIsOpen(false);
    };

    // Function to toggle between French and English
    const toggleLanguage = () => {
        const newLang = i18n.language === 'fr' ? 'en' : 'fr';
        i18n.changeLanguage(newLang);
        if (typeof window !== 'undefined') {
            localStorage.setItem('language', newLang);
        }
        console.log(localStorage)
    };



    return (
        <Navbar 
            fixed="top" 
            id="navbar"
            expand="lg" 
            expanded={isOpen}
            onToggle={() => setIsOpen(!isOpen)}
            className={`component transition-all duration-300 bg-transparent`}
            style={{
                boxShadow: isScrolled ? isDarkMode ? '0 4px 15px rgba(255, 255, 255, 0.1)' : '0 4px 4px rgba(0, 0, 0, 0.1)' : 'none',
            }}
            >
            <Container
            style={{
                backgroundColor: isScrolled 
                ? isDarkMode ? '#182729' : '#FAFAFA'
                : 'transparent',
                transition: 'all 300ms',
                padding: 0,
                color: isDarkMode ? 'white' : undefined,
            }}
            >
            <Navbar.Brand className={"w-1/2 md:w-1/4 lg:w-1/5 xl:w-1/4 font-handlee font-bold italic"} href="/">
                <Image 
                    src={isDarkMode 
                        ? "/images/logo/logo-transparent-white contours.png" 
                        : "/images/logo/logo-transparent-black thick contours.png"
                    }
                    alt="SoBoo Logo"
                    width={100}
                    height={100}
                    className={isScrolled ? "scrolled" : undefined} 
                    id="logo"
                    objectFit="contain"
                    priority
                />
                <h1 className={`dark:text-white ${isScrolled ? "scrolled" : undefined}`}>Sail on Bamboo</h1>
            </Navbar.Brand>
            <Navbar.Toggle 
                aria-controls="basic-navbar-nav"
                className={isDarkMode ? "dark" : ""}/>
            <Navbar.Collapse 
                id="basic-navbar-nav">
                <Nav className={"font-jost font-bold" }>
                    {isOpen && < IoCloseOutline 
                        className="md:text-regular"
                        onClick={() => setIsOpen(false)}/>}
                    {Object.keys(tabs).map((key) => (
                        <Nav.Link
                            className={`${
                                isScrolled ? 'py-0 scrolled' : 'py-5 md:py-0'
                            } ${isDarkMode ? 'dark-link' : ''} ${
                                activeKey === key ? (isDarkMode ? 'dark-active' : 'active') : ''
                            }`}
                            key={key}
                            href={`${tabs[key].path}`}
                            onClick={() => handleNavClick(key)}
                            >
                            {tabs[key].label}
                        </Nav.Link>
                    ))}
                </Nav>
                <div className="icon w-1/4 lg:w-1/5 xl:w-1/4 flex flew-row justify-end gap-4 pl-3 pr-10">
                <Link
                    href="https://www.instagram.com/sailonbamboo_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className={"nav-link cursor-pointer " + (isScrolled ? "scrolled" : "")}>
                    <FaInstagram />
                </Link>
                < Link 
                    href = "/contact" 
                    className={"nav-link cursor-pointer " + (isScrolled ? "scrolled" : "")}
                    onClick={() => handleNavClick('contact')} >
                    <MdOutlineContactSupport/>
                </Link>
                <div 
                    className={"nav-link cursor-pointer relative " + (isScrolled ? "scrolled" : "")}
                    onClick={toggleLanguage}>
                    <TfiWorld />
                    <p 
                        className={`absolute bottom-0 m-0 px-0.5 -right-3 leading-none text-override ${isDarkMode ? 'bg-dark' : 'bg-white'}`}
                        >{isScrolled ? (i18n.language === 'fr' ? 'EN' : 'FR') : ''}</p>
                </div>
                </div>
            </Navbar.Collapse>
            </Container>
        </Navbar>
    );
    }

export default MainNavbar;